import request from '@/utils/request'
// 快递员审核API

export function qryCourierInfo(query) {
  return request({
    url: '/api/user/qryCourierInfo',
    method: 'post',
    params: query
  })
}
export function courierValid(query) {
  return request({
    url: '/api/user/courierValid',
    method: 'post',
    params: query
  })
}
